import React from 'react';
import { Loader2 } from 'lucide-react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <Loader2 
        className={`animate-spin ${sizeClasses[size]}`} 
        style={{color: 'var(--liquid-text-primary)'}}
      />
      {text && (
        <p className="text-sm opacity-70" style={{color: 'var(--liquid-text-muted)'}}>
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;




